<template>
  <div>
    <div class="flex flex-col pb-4"
      name="advancedSearchForm">
      <h6 class="text-left">Search</h6>
      <form name="advanced_search_form" @submit="onSubmit">
        <div class="flex flex-col content-center items-center gap-3">
          <div class="flex flex-row w-full gap-2">
            <Input
              class="!border border-gray-100 rounded-sm grow outline-none text-md px-3 py-2 placeholder-gray-600"
              placeholder="Type to search"
              v-model="searchbarKeyword"
              @input="updateFilters">
            </Input>
            <div class="flex-row">
              <button
                class="inline-flex items-center rounded-l-lg bg-white shadow-sm h-10 p-2 hover:!bg-gray-50"
                type="submit"
                :disabled="!searchbarKeyword"
                value="search">
                <svg
                  v-show="displayIcons"
                  class="ml-2 h-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor" >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                Search
              </button>
              <button
                class="inline-flex items-center rounded-none bg-white shadow-sm h-10 p-2 hover:!bg-gray-50"
                type="submit"
                :disabled="!searchbarKeyword"
                value="clear">
                <svg
                  v-show="displayIcons"
                  class="ml-2 h-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor" >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
                Clear
              </button>
              <button
                class="inline-flex items-center rounded-r-lg bg-white shadow-sm h-10 p-2 hover:!bg-gray-50"
                @click="isAdvancedSearch = !isAdvancedSearch">
                {{ isAdvancedSearch ? 'Hide Advanced Search' : 'Show Advanced Search' }}
              </button>
            </div>
          </div>
          <div class="my-1 px-12 w-full"
            v-show="isAdvancedSearch">
            <div
              v-for="(filter, index) in filters"
              :key="index">
              <div class="grid grid-cols-9 gap-7 items-end">
                <SelectionField
                  v-if="index !== 0"
                  class="pb-2"
                  v-model="filter.logic"
                  :options="['and', 'or']"
                  @input="updateSearchbar(index)">
                  Logic
                </SelectionField>
                <div class="h-full flex justify-center items-center"
                  v-else>
                  <span>---</span>
                </div>
                <div class="flex flex-row col-span-2 w-full">
                  <XButton
                    class="align-self-center mt-2 p-1 w-4 h-4 rounded-lg bg-gray-200"
                    @click="removeFieldSelection(index)">
                  </XButton>
                  <SelectionField
                    class="pb-2 col-span-2"
                    v-model="filter.field"
                    :options="searchbarList"
                    @input="updateSearchbar(index)">
                    Select a Filter
                  </SelectionField>
                </div>
                <div class="col-span-5">
                  <SelectionField
                    v-if="filter.field == 'grade'"
                    class="pb-2"
                    v-model="filter.keyword"
                    :options="gradeList"
                    @input="updateSearchbar(index)">
                    Select a Filter
                  </SelectionField>
                  <CalendarField
                    v-else-if="filter.field == 'startDate' || filter.field =='endDate'"
                    class="pb-2"
                    v-model="filter.keyword"
                    @input="updateSearchbar(index)">
                    Select a Date
                  </CalendarField>
                  <TextField
                    v-else
                    class="pb-2"
                    placeholder="Input Search Keyword"
                    v-model="filter.keyword"
                    @input="updateSearchbar(index)">
                    Search
                  </TextField>
                </div>
                <div class="h-full flex items-center">
                  <XButton
                    class="p-1 w-5 h-5 rounded-lg bg-orange-400"
                    @click="removeFilter(index)">
                  </XButton>
                </div>
              </div>
            </div>
            <Button
              class="my-2 p-2 rounded-md"
              color="blue"
              :disabled="filters.length >= maxAdvancedFilters"
              @click="addFilter">
              Add Filter
            </Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Input from '../Input.vue'
import SelectionField from '../formComponents/SelectionField.vue'
import TextField from '../formComponents/TextField.vue'
import CalendarField from '../formComponents/CalendarField.vue'
import Button from '../Button.vue'
import XButton from '../XButton.vue'

import user from '../../services/user/user.js'

import DropdownLists from '../DropdownLists.json'
import { isObject, isArray } from 'lodash'

export default {
  components: {
    Input,
    SelectionField,
    TextField,
    CalendarField,
    Button,
    XButton,
  },
  props: {
    displayIcons: Boolean,
    searchInput: String,
    showInternalId: Boolean,
    listName: String,
    value: undefined,
    maxAdvancedFilters: {
      type: Number,
      default: 16,
    },
    searchbarListOverride: undefined
  },
  data() {
    return {
      user: undefined,

      filters: [
        {
          logic: undefined,
          field: undefined,
          keyword: undefined,
        }
      ],

      isAdvancedSearch: false,
      searchbarKeyword: '',

      searchbarList: this.searchbarListOverride != undefined ? this.searchbarListOverride : DropdownLists.SearchbarList,
      gradeList: DropdownLists.gradeList,
    }
  },
  methods: {
    emitFiltersUpdated() {
      this.$emit('input', this.filters)
      this.$emit('filtersUpdated')
    },
    onSearch() {
      this.emitFiltersUpdated()
      this.$emit('search')
    },
    onSearchClear() {
      this.searchbarKeyword = ''
      this.resetFilters()
      this.$emit('searchClear')
      this.onSearch()
    },
    onSubmit(submitEvent) {
      // This is required to prevent the HTML <form> field from adding
      //   an entry in the browser's navigation history.
      // Turns out this breaks clicking into a new tab.
      submitEvent.preventDefault()

      switch (submitEvent.submitter.value) {
        case 'search':
          this.onSearch()
          break
        case 'clear':
          this.onSearchClear()
          break
      }
    },
    updateSearchbar(index) {
      if (this.filters.length === 1) {
        this.searchbarKeyword = this.filters[0].keyword
      }
      else if (this.filters.length > 1) {
        this.searchbarKeyword = `${this.filters[0].keyword} and/or ...`
      }
      return index
    },
    updateFilters() {
      if (this.filters.length === 1) {
        this.filters[0].keyword = this.searchbarKeyword
      }
    },
    buildFilters() {
      try {
        let parseFilters = JSON.parse(this.searchInput)
        if (isArray(parseFilters)) {
          for (let i = 0; i < parseFilters.length; ++i) {
            if (this.filters.length <= i) {
              this.addFilter()
            }
            if (parseFilters[i].keyword) this.filters[i].keyword = parseFilters[i].keyword
            if (parseFilters[i].field)   this.filters[i].field = parseFilters[i].field
            if (parseFilters[i].logic)   this.filters[i].logic = parseFilters[i].logic
          }
          // this.$set(this, 'filters', parseFilters)
        }
        else if (isObject(parseFilters)) {
          this.filters[0].keyword = parseFilters.keyword
          this.filters[0].field = parseFilters.field
        }

        this.updateSearchbar()
      }
      catch {
        this.resetFilters()
        this.filters[0].keyword = this.searchInput
        this.updateSearchbar()
      }
    },
    addFilter() {
      let newFilter = {
        logic: undefined,
        field: undefined,
        keyword: undefined,
      }
      if (this.filters === undefined) {
        this.$set(this, 'filters', [ newFilter ])
      }
      else {
        if (this.filters.length < this.maxAdvancedFilters) {
          this.filters.push(newFilter)
        }
      }
    },
    removeFilter(index) {
      this.filters.splice(index, 1)
      if (this.filters.length === 0) {
        this.resetFilters()
      }
    },
    removeFieldSelection(index) {
      this.$delete(this.filters[index], 'field')
    },
    resetFilters() {
      this.searchbarKeyword = ''
      this.filters = [
        {
          logic: undefined,
          field: undefined,
          keyword: undefined,
        }
      ]
    },
    setSearchBar(newValue) {
      if (this.filters.length === 0) {
        this.addFilter()
      }
      this.searchbarKeyword = newValue
      this.filters[0].keyword = this.searchbarKeyword
    }
  },
  async mounted() {
    this.setSearchBar(this.searchInput)

    this.user = await user.get()
    if (this.user?.can('view_internal_cst_data')) {
      this.searchbarList = Object.assign(
        { internalId: 'Internal ID' },
        this.searchbarList
      )
    }
  },
  watch: {
    value(newValue) {
      this.formValues = newValue
    },
    searchInput: function () {
      this.buildFilters()
    }
  }
}
</script>
